var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3.5 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.746 9c0 3.886-2.46 7.334-6.1 8.549-3.639 1.214-7.636-.078-9.912-3.205l-.293.893-1.403-.474.74-2.25c.1-.307.383-.513.7-.513h2.22v1.5h-.74c1.91 2.582 5.234 3.636 8.254 2.615 3.019-1.02 5.056-3.887 5.056-7.115zM6.1.451c3.64-1.214 7.637.078 9.912 3.205l.294-.893 1.403.474-.74 2.25c-.1.307-.383.513-.701.513h-2.219V4.5h.74c-1.399-1.886-3.589-2.997-5.916-3-4.082.005-7.39 3.36-7.394 7.5H0C0 5.114 2.46 1.666 6.1.451z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshWhite);
export default __webpack_public_path__ + "static/media/refresh-white.9243a03403d5862b9d169819965f3a95.svg";
export { ForwardRef as ReactComponent };